import React from "react";
import MeaPage from "../../../components/MeaPage";
import UserSchoolsListComponent from "./components/UserSchoolsListComponent";

const UserSchoolsDetailPage = () => {
  return (
    <>
      <MeaPage
        title="Mes écoles"
        subtitle="Retrouvez vos établissements et accédez rapidement à votre espace de travail."
      >
        <UserSchoolsListComponent />
      </MeaPage>
    </>
  );
};
export default UserSchoolsDetailPage;
